import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useQuery, useMutation, useQueryClient } from "react-query";

export function useWWGNews() {
  const queryClient = useQueryClient();

  const { data, status, isLoading, refetch } = useQuery(["news-settings"], () =>
    makeAuthedRequest("v1/settings/news-settings", {
      method: "GET",
    }).then(async (res) => {
      if (res.ok) {
        return res.text();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const updateNewsSettings = useMutation(
    (data) =>
      makeAuthedRequest("v1/settings/news-settings", {
        method: "POST",
        body: JSON.stringify(data),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("news-settings");
      },
    }
  );

  return {
    data,
    status,
    isLoading,
    refetch,
    updateNewsSettings,
  };
}
